import { createFileRoute } from "@tanstack/react-router";
import WorkspaceTeamPage from "@/components/settings/workspace/workspace-team-page";

/** Legacy /settings/team -> same team list as workspace team. */
export const Route = createFileRoute("/_app/settings/team/")({
	component: () => <WorkspaceTeamPage />,
});
